import React from 'react'
import {connect} from 'react-redux'

class ArenaBackgroundStyle extends React.Component {

  render() {
    const style = {
      position:"absolute",
      left:0, top:0, right: 0, bottom: 0,
      background: this.props.arenaBackgroundStyle,
      transition: "background 0.8s"
    };
    return (
      <div style={style}/>
    );
  }
}

export default connect((state, props) => {
  return {
    arenaBackgroundStyle: state.battle.arenaBackgroundStyle
  }
})(ArenaBackgroundStyle)


// WEBPACK FOOTER //
// ./src/battle/ArenaView/ArenaBackgroundStyle.js